import { render } from "./CheckBoxDokter.vue?vue&type=template&id=4daeb3bd"
import script from "./CheckBoxDokter.vue?vue&type=script&lang=js"
export * from "./CheckBoxDokter.vue?vue&type=script&lang=js"

import "./CheckBoxDokter.vue?vue&type=style&index=0&id=4daeb3bd&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__